import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { MobileNav } from './MobileNav';
import { useWorkspaceSSE } from '@/hooks/useWorkspaceSSE';
import { useBillingStore } from '@/stores/useBillingStore';
import { useWorkspaceStore } from '@/stores/useWorkspaceStore';
import { useGetApiWorkspaces } from '@/api/generated/workspaces/workspaces';
import { OnboardingTour } from '@/components/onboarding/OnboardingTour';
import { WelcomeModal } from '@/components/onboarding/WelcomeModal';
import { UpgradeModal } from '@/features/billing/components/UpgradeModal';
import { ActiveSubscriptionWarningModal } from '@/features/workspaces/components/ActiveSubscriptionWarningModal';

import { useNavigate } from 'react-router-dom';

export const AppShell: React.FC = () => {
  useWorkspaceSSE();
  const fetchStatus = useBillingStore((state) => state.fetchStatus);
  const { activeWorkspaceId, workspaces, setWorkspaces } = useWorkspaceStore();
  const navigate = useNavigate();

  const { data: workspacesData, isSuccess: isWorkspacesSuccess } = useGetApiWorkspaces();

  useEffect(() => {
    if (workspacesData) {
      setWorkspaces(workspacesData);
    }
  }, [workspacesData, setWorkspaces]);

  useEffect(() => {
    const isValidWorkspace = workspaces.some((w) => w.id === activeWorkspaceId);
    if (activeWorkspaceId && isValidWorkspace) {
      fetchStatus(activeWorkspaceId);
    }
  }, [activeWorkspaceId, workspaces, fetchStatus]);

  useEffect(() => {
    if (isWorkspacesSuccess && Array.isArray(workspacesData) && workspacesData.length === 0) {
      navigate('/no-workspaces', { replace: true });
    }
  }, [isWorkspacesSuccess, workspacesData, navigate]);

  return (
    <div className="h-screen w-screen flex overflow-hidden bg-background text-foreground">
      {/* Onboarding Welcome Greeting Modal & Tour */}
      <WelcomeModal />
      <OnboardingTour />
      <UpgradeModal />
      <ActiveSubscriptionWarningModal />

      {/* Desktop Collapsible & Lockable Sidebar */}
      <div className="hidden md:flex flex-shrink-0 z-30 h-full">
        <Sidebar />
      </div>

      {/* Mobile Slide-Over Navigation Drawer */}
      <MobileNav />

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col min-w-0 h-full overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto min-h-0 bg-background">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AppShell;
